import React, { useState } from 'react';
import {
  Grid, Tooltip, Box, ClickAwayListener,
} from '@mui/material';
import {
  WITH_MOTORCYCLE,
  WITHOUT_MOTORCYCLE,
  BOTH,
} from 'views/rebranded-module/common/utils/constants';
import Typography500 from 'views/common/components/UI/Typography500';
import StyledBox from 'views/rebranded-module/tours-module/TourViewV2/components/IncludedSection/IncludedSection.styles';
import { RiCheckboxCircleFill, RiInformationLine } from 'react-icons/ri';

const IncludedSection = (props) => {
  const { inclusions, includeBike, content } = props;
  const [openTooltip, setOpenTooltip] = useState(null); // Track open tooltip by index
  const filterCondition = includeBike ? WITH_MOTORCYCLE : WITHOUT_MOTORCYCLE;
  const filterItems = (items) => {
    if (items) {
      return items.filter(
        (item) => item.visible_for === filterCondition || item.visible_for === BOTH,
      );
    }
    return null;
  };
  const filteredIncludedItems = inclusions && filterItems(inclusions.included_items);
  return (
    <StyledBox>
      <Grid container spacing={0}>
        <Grid
          item
          lg={2}
          md={2}
          sm={4}
          className="ISIncludedGrid ISIncludedLeftGrid ISIncludedCell">
          <Typography500 component="p" variant="body1">
            {content.included}
          </Typography500>
        </Grid>
        <Grid item lg={10} md={10} sm={8} />
      </Grid>
      {filteredIncludedItems.map((item) => (
        <Grid
          container
          spacing={0}
          key={item.name}
          className="ISIncludedItemsGrid">
          <Grid
            item
            lg={2}
            md={2}
            sm={4}
            className="ISIncludedGrid ISIncludedLeftGrid">
            <RiCheckboxCircleFill className="ISIncludedIcon" />
          </Grid>
          <Grid item lg={10} md={10} sm={8} className="ISIncludedGrid">
            <Typography500 component="p" variant="body2">
              {item.name}
              {item.description && (
                <>
                  <Box component="span" className="showDESKTOP">
                    <Tooltip title={item.description} placement="top" arrow>
                      <Box component="span">
                        <RiInformationLine className="ISInfoIcon" />
                      </Box>
                    </Tooltip>
                  </Box>
                  <Box component="span" className="showTABLET">
                    <ClickAwayListener onClickAway={() => setOpenTooltip(null)}>
                      <Box component="span">
                        <Tooltip
                          title={item.description}
                          placement="top"
                          arrow
                          open={openTooltip === item}
                          disableFocusListener
                          disableHoverListener
                          disableTouchListener>
                          <Box
                            component="span"
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenTooltip((prev) => (prev === item ? null : item));
                            }}>
                            <RiInformationLine className="ISInfoIcon" />
                          </Box>
                        </Tooltip>
                      </Box>
                    </ClickAwayListener>
                  </Box>
                </>
              )}
            </Typography500>
          </Grid>
        </Grid>
      ))}
    </StyledBox>
  );
};
export { IncludedSection };
